var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3737 19.9596L15.79 14.376C16.9619 12.8978 17.6667 11.0327 17.6667 9C17.6667 4.21354 13.7865 0.333336 9.00004 0.333336C4.21358 0.333336 0.333374 4.21354 0.333374 9C0.333374 13.7865 4.21358 17.6667 9.00004 17.6667C11.0327 17.6667 12.8979 16.9619 14.3759 15.79L19.9597 21.3737C20.155 21.569 20.4108 21.6667 20.6667 21.6667C20.9226 21.6667 21.1784 21.569 21.3737 21.3737C21.7644 20.9831 21.7644 20.3502 21.3737 19.9596ZM2.33337 9C2.33337 5.32404 5.324 2.33333 9.00004 2.33333C12.6761 2.33333 15.6667 5.32404 15.6667 9C15.6667 12.676 12.6761 15.6667 9.00004 15.6667C5.324 15.6667 2.33337 12.676 2.33337 9Z",
    fill: "#6CB6E3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.1587c6a3c119aef799555c9b2c0c82b0.svg";
export { ForwardRef as ReactComponent };